/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../product_type';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "external": {
            "nested": {
              "DeviceCode": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "code": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "deviceId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "productType": {
                    "type": "squareup.devicesettings.ProductType",
                    "id": 5,
                    "rule": "optional"
                  },
                  "locationId": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "status": {
                    "type": "squareup.devicesettings.external.DeviceCode.Status",
                    "id": 9,
                    "rule": "optional"
                  },
                  "pairBy": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "statusChangedAt": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "pairedAt": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Status": {
                    "values": {
                      "UNKNOWN": 0,
                      "UNPAIRED": 1,
                      "PAIRED": 2,
                      "EXPIRED": 3
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.external?.nested?.DeviceCode && !$root.nested?.squareup?.nested?.devicesettings?.nested?.external?.nested?.DeviceCode?.nested?.Status) {
  $root.addJSON(jsonData);
}

/**
 * External DeviceCode Representation
 *
 * SOURCE DeviceCode @ squareup/devicesettings/external/device_code.proto at 16:1
 */
export const DeviceCode = $root.lookupType('squareup.devicesettings.external.DeviceCode');
fixType(DeviceCode, {
  productType: {
    required: true
  }
});
Builder.createAndAttachToType(DeviceCode);
/**
 * --
 * @desc DeviceCode.Status enum.
 * --
 *
 * SOURCE Status @ squareup/devicesettings/external/device_code.proto at 51:3
 */
DeviceCode.Status = $root.lookupEnum('squareup.devicesettings.external.DeviceCode.Status').values;